'use client';

import { useEffect } from 'react';
import {
  ThemeProvider as NextThemesProvider,
  type ThemeProviderProps,
} from 'next-themes';

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  useEffect(() => {
    document.documentElement.classList.add('theme-transition');

    return () => {
      document.documentElement.classList.remove('theme-transition');
    };
  }, []);

  return <NextThemesProvider {...props}>{children}</NextThemesProvider>;
}
